import { useEffect, useState } from "react";

export type KeyboardHeight = number | null;

export const useKeyboardHeight = () => {
  const [keyboardHeight, setKeyboardHeight] = useState<KeyboardHeight>(null);

  const updateKeyboardHeight = () => {
    if (window.visualViewport == null) {
      setKeyboardHeight(null);
      return;
    }
    const potentialKeyboardHeight =
      window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;
    if (potentialKeyboardHeight <= 0) {
      setKeyboardHeight(null);
      return;
    }
    setKeyboardHeight(potentialKeyboardHeight);
  };

  useEffect(() => {
    window.visualViewport?.addEventListener("resize", updateKeyboardHeight);
    return () => window.visualViewport?.removeEventListener("resize", updateKeyboardHeight);
  }, []);

  return keyboardHeight;
};
